import React from "react";
import { Table, Button } from "react-bootstrap";

const DataTable = ({ headers, data, dataKeyMap, actions, imagePath = "" }) => {
    return (
        <Table striped bordered hover>
            <thead>
                <tr>
                    {headers.map((header, index) => (
                        <th key={index}>{header}</th>
                    ))}
                    {actions && <th>Actions</th>}
                </tr>
            </thead>
            <tbody>
                {data.length > 0 ? (
                    data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {dataKeyMap.map((key, index) => (
                                <td key={index}>
                                    {key === "image" ? (
                                        Array.isArray(row[key]) ? ( // Check if images are in an array
                                            row[key].length > 0 ? (
                                                row[key].map((img, i) => (
                                                    <img
                                                        key={i}
                                                        src={img ? `${imagePath}${img}` : "/default-image.jpg"}
                                                        alt={`Image ${i}`}
                                                        style={{
                                                            width: "50px",
                                                            height: "50px",
                                                            objectFit: "cover",
                                                            marginRight: "5px",
                                                        }}
                                                    />
                                                ))
                                            ) : (
                                                <img
                                                    src="/default-image.jpg"
                                                    alt="Default"
                                                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                                />
                                            )
                                        ) : (
                                            <img
                                                src={row[key] ? `${imagePath}${row[key]}` : "/default-image.jpg"}
                                                alt="Service"
                                                style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                            />
                                        )
                                    ) : (
                                        row[key]
                                    )}
                                </td>
                            ))}
                            {actions && (
                                <td>
                                    {actions.map((action, index) => (
                                        <Button
                                            key={index}
                                            variant={action.variant || "primary"}
                                            onClick={() => action.onClick(row)}
                                            className="me-2"
                                        >
                                            {action.label}
                                        </Button>
                                    ))}
                                </td>
                            )}
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={headers.length + 1} className="text-center">
                            No data available
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
};

export default DataTable;

